angular.module("Main").controller("WaitlistSuccessController", ["$rootScope", "$scope", "$state", "$stateParams", "$location", "$translate", "$localStorage", "$window","PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $location, $translate, $localStorage, $window, PaymentService, BookingService, SessionService) {
        var vm = this;

        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }
        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        var logoutHandler = $rootScope.$on("logout", function () {
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        });

        vm.isKurs = true;
        vm.isTermin = false;
        vm.cookies = SessionService.checkSession();
        vm.currentUser = $localStorage.user;

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;


        if (!SessionService.getSessionId()) {
            $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;
            let userData = $localStorage.user;
            //ToDo cookies nach reload
            if ($state.is("success_waitlist")) {
                vm.kursData = ({
                    Name: vm.cookies.kursData.kurs.Bezeichnung,
                    PreisZahl: vm.cookies.kursData.kurs.PreisZahl,
                    Start: vm.cookies.kursData.kurs.Start,
                    Ende: vm.cookies.kursData.kurs.Ende,
                    Tag: vm.cookies.kursData.kurs.Tag,
                    PersonNr: vm.currentUser.memberNr,
                    RessourcenIds: vm.cookies.kursData.kurs.RessourcenIds
                });
                getDataForConfirm();
                BookingService.saveAppointmentHistory(vm.cookies.kursData.kurs.Nr, 13, 4,
                    {s3Nr: userData.uid});
            }
        }

        function getDataForConfirm() {
            vm.personNr = vm.kursData.PersonNr;
            let userData = $localStorage.user;
            BookingService.getUserDetails(userData.uid).then(function (data) {
                vm.memberNr = vm.personNr;
                vm.isMember = $localStorage.user.username !=='' ? $localStorage.user.isMember : false;
                vm.isLoggedIn =!_.isNil(userData) && !_.isUndefined($localStorage.user.username);
                vm.member = $localStorage.user;
                vm.member.firstname = $localStorage.user.Firstname;
                vm.member.lastname = $localStorage.user.Lastname;
                vm.member.email = $localStorage.user.Email;
                if (!_.isNil(data)) {
                    vm.isLoggedIn = true;
                    vm.username = data.firstname + " " + data.lastname;
                    vm.hideLogin = true;
                    $rootScope.$emit("login");
                }
            }).then(function () {
                var arr = JSON.parse(vm.kursData.RessourcenIds);
                var ids = arr.map(Number)
                BookingService.getResourceNames(ids).then(function (data) {
                    let MitarbeiterRessource = _.sortBy(_.filter(data, {Mitarbeiter: 1}), 'Bezeichnung');
                    let NichtMitarbeiterRessource = _.sortBy(_.filter(data, {Mitarbeiter: 0}), 'Bezeichnung');
                    vm.kursData.ressources = _.concat(MitarbeiterRessource, NichtMitarbeiterRessource);
                })
            });
        }

}]);
